/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import Lista_Tarjeta_Proyectos_Home from "./SubComponentes/Lista_Tarjeta_Proyectos_Home";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Proyectos_Home = () => {
    const {sCell} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={12}>


            <Grid2 container size={12}
                   sx={{maxWidth: '1400px', px: 3,}}>

                <Grid2 container size={{xs: 12, sm: 12, md: 11}}>

                    <Grid2 container
                           justifyContent={'center'}
                           size={12}
                           sx={{mb: 16}}>
                        <Typography sx={{fontSize: sCell ? 40 : 48, fontWeight: 800, textAlign: 'center', lineHeight: 1.1}}>
                            Proyectos realizado o en curso
                        </Typography>
                    </Grid2>

                    <Grid2 container size={{xs: 12, sm: 12, md: 12}}>

                        <Lista_Tarjeta_Proyectos_Home/>

                    </Grid2>

                </Grid2>


            </Grid2>

        </Grid2>
    )

}
export default Proyectos_Home